/* eslint-disable class-methods-use-this */
import {
    KeyboardEventHandler, ReactNode,
} from 'react'
import {
    Compatible,
    NumberCellTemplate,
    NumberCell,
    keyCodes,
    inNumericKey,
    isNavigationKey,
    isAllowedOnNumberTypingKey,
    isCharAllowedOnNumberInput, getCharFromKey,
} from '@silevis/reactgrid'
import {
    parseLocaleNumber,
} from 'app/shared-components/SkyNetSpreadSheet/customTemplates/NumberCellTemplate/parseLocalNumber'

import SkyNetNumberCell from './SkyNetNumberCell'

export default class SkyNetCustomNumberCellTemplate extends NumberCellTemplate {
    /* same as original, can't inherit private props */
    private customWasEscKeyPressed = false

    /* same as original, can't inherit private props */
    private customGetTextFromCharCode = (cellText: string): string => {
        switch (cellText.charCodeAt(0)) {
        case keyCodes.DASH:
        case keyCodes.FIREFOX_DASH:
        case keyCodes.SUBTRACT:
            return '-'
        case keyCodes.COMMA:
            return ','
        case keyCodes.PERIOD:
        case keyCodes.DECIMAL:
            return '.'
        default:
            return cellText
        }
    }

    private onKeyDownHandler = ((e) => {
        if (
            inNumericKey(e.keyCode)
            || isNavigationKey(e.keyCode)
            || isAllowedOnNumberTypingKey(e.keyCode)
            || ((e.ctrlKey || e.metaKey) && e.keyCode === keyCodes.KEY_A)
        ) e.stopPropagation()
        if (
            !inNumericKey(e.keyCode)
            && !isNavigationKey(e.keyCode)
            && !isCharAllowedOnNumberInput(getCharFromKey(e.key))
        ) e.preventDefault()
        if (e.keyCode === keyCodes.ESCAPE) this.customWasEscKeyPressed = true
    }) as unknown as (e: KeyboardEventHandler<HTMLInputElement>) => void

    render(
        cell: Compatible<NumberCell>,
        isInEditMode: boolean,
        onCellChanged: (
            cell: Compatible<NumberCell>,
            commit: boolean
        ) => void,
    ): ReactNode {
        if (!isInEditMode) {
            return super.render(cell, isInEditMode, onCellChanged)
        }

        const locale = cell.format
            ? cell.format.resolvedOptions().locale
            : window.navigator.languages[0]
        const format = new Intl.NumberFormat(locale, {
            useGrouping: false, maximumFractionDigits: 20,
        })

        return (
            <SkyNetNumberCell
                onChange={(e, commit: boolean = false) => {
                    return onCellChanged(this.getCompatibleCell({
                        ...cell, value: parseLocaleNumber(e.currentTarget.value),
                    }), commit)
                }}
                cell={cell}
                value={cell.value}
                defaultValue={Number.isNaN(cell.value)
                    ? this.customGetTextFromCharCode(cell.text) : format.format(cell.value)}
                onBlur={(e) => {
                    onCellChanged(
                        this.getCompatibleCell({
                            ...cell, value: parseLocaleNumber(e.currentTarget.value),
                        }),
                        !this.customWasEscKeyPressed,
                    )
                    this.customWasEscKeyPressed = false
                }}
                onKeyDown={this.onKeyDownHandler}
            />
        )
    }
}
